module.exports = __webpack_public_path__ + "static/03-6f90dba3cc2499d5f6716fc51102c75a.jpg";